export const contactsData = {
    email: 'abhishekchoubeyofficial12@gmail.com',
    phone: '+918770207441',
    address: 'Indore, Madhya Padesh, India ',

    sheetAPI: ''
}